import { Input, Skeleton } from "@marketplace/ui";
import { lazy, Suspense } from "react";

// Lazy load the entire rich text editor component to reduce initial bundle size
const LazyProductFormDescriptionInner = lazy(() =>
  import("./product-form-description-inner").then((mod) => ({
    default: mod.ProductFormDescriptionInner
  }))
);

interface ProductFormDescriptionProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  label: string;
  placeholder?: string;
  withAsterisk?: boolean;
}

export const ProductFormDescription: React.FC<ProductFormDescriptionProps> = (
  props
) => {
  return (
    <Suspense
      fallback={
        <Input.Wrapper
          label={props.label}
          withAsterisk={props.withAsterisk}
          error={props.error}
        >
          <Skeleton height={200} radius={8} />
        </Input.Wrapper>
      }
    >
      <LazyProductFormDescriptionInner {...props} />
    </Suspense>
  );
};
